import { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  buttonText?: string;
  icon?: React.ReactNode;
  onButtonClick?: () => void;
  className?: string;
  children?: ReactNode;
  hideButton?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  buttonText,
  icon,
  onButtonClick,
  className = "",
  children,
  hideButton,
}) => {
  return (
    <div
      className={`px-3 py-2 bg-gray-light rounded-md flex justify-between items-center mb-4 min-h-[55px] ${className}`}
    >
      <div className="flex items-center gap-4">
        <h4 className="text-display-body text-lg font-semibold leading-[30px]">
          {title}
        </h4>
        {children}
      </div>
      {!hideButton && buttonText && (
        <button
          className="text-primary text-sm font-medium sm-button gap-2"
          onClick={onButtonClick}
          type="button"
        >
          {icon}
          <span>{buttonText}</span>
        </button>
      )}
    </div>
  );
};

export default SectionHeader;
